import React, { PropTypes } from 'react';
import classnames from 'classnames';
import { emojify } from 'react-emojione';
import emojisShortNames from 'emoji-shortnames';

import './style.scss';

const Emojis = props => {
  const className = classnames(
    'Emojis',
    {
      'is-under-textarea': props.isUnderTextArea,
      'is-visible': props.isVisible
    });

  function handleEmojiClick(event) {
    const shortName = event.target.getAttribute('label');
    props.onEmojiSelected(shortName);
  }

  return (
    <div className={className}>
      <div className="emoji-list">
        {emojisShortNames.people.slice(0, 50).map(shortName => {
          return <span key={shortName} label={shortName} onClick={handleEmojiClick} className="icon">{emojify(shortName, {output: 'unicode'})}</span>;
        })}
      </div>
    </div>
  );
};

Emojis.propTypes = {
  isUnderTextArea: PropTypes.bool,
  isVisible: PropTypes.bool,
  onEmojiSelected: PropTypes.func
};

export default Emojis;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Emojis/index.js
 **/